import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Row, Col, Input, InputGroup, InputGroupAddon, Button, Table, ButtonGroup, Card, CardBody, CardHeader } from 'reactstrap';

import { Range, getTrackBackground, checkValuesAgainstBoundaries, relativeValue } from 'react-range';
import { sendRequest } from '../../../hooks/requests/useRequest';
import { validarSesion } from '../../../hooks/tokens/useToken';
import { useHistory } from 'react-router-dom';
import { useDebounce } from '../../../hooks/debounce/useDebounce';
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSweetAlert } from '../../../hooks/sweetAlerts/useSweetAlert';

const STEP = 0.01;
const COLORS = ['#f5365c ', '#ffd600 ', '#2dce89', '#ffd600 ', "#f5365c "];


export const ReferenceValues = ({ name, tabTypeAnalyte, listRanges, saveTempAnalytesNumberAlerts, listReferenceValues, saveTempAnalytesTextAlerts, listReferenceTexts, }) => {

    const history = useHistory();
    const { innerHeight: height } = window;
    const [analyteNumberAlertId, setAnalyteNumberAlertId] = useState(0);
    const [values, setValues] = useState([20, 40, 60, 80]);
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(100);
    const [inputValues, setInputValues] = useState({ min: 0, max: 100 });
    const [rangoId, setRangoId] = useState(0);
    const [errorSelect, setErrorSelect] = useState(0);
    const [rangos, setRangos] = useState([]);
    const [rangosT, setRangosT] = useState([]);
    const [methodActive, setMethodActive] = useState("create");
    const [nameRange, setNameRange] = useState("");
    const [valoresReferencia, setValoresReferencia] = useState([]);
    // console.log("🚀 ~ ReferenceValues ~ valoresReferencia:", valoresReferencia)
    const [inputIndex, setInputIndex] = useState(-1);
    // ////console.log(listReferenceValues,"Como llega aqui?");

    const debounceValue = useDebounce(values, 2000);
    const [inferiorLimitNotAlert, setInferiorLimitNotAlert] = useState(values[0]);
    const [normalValue, setNormalValue] = useState(values[1]);
    const [normalMaxValue, setNormalMaxValue] = useState(values[2]);
    const [superiorValue, setSuperiorValue] = useState(values[3]);


    const [analyteTextAlertId, setAnalyteTextAlertId] = useState(0);
    const [textosReferencia, setTextosReferencia] = useState([]);
    // console.log("🚀 ~ ReferenceValues ~ textosReferencia:", textosReferencia)
    const [inputText, setInputText] = useState("");
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate,sweetDeleteBacterium1,sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal,sweetAcceptGlobal, sweetAlertGlobal,createSweetSend] = useSweetAlert();
    const [isEdited, setIsEdited] = useState(false);


    const handleRangeLimit = ({ target }) => {
        setIsEdited(true); 
        if (target.name === "min") {
            setInputValues({
                ...inputValues,
                min: target.value
            })
        } else {
            setInputValues({
                ...inputValues,
                max: target.value
            })
        }
    }

    const changeInputText = ({ target }) => {
        setIsEdited(true); 
        setInputText(target.value);
    }

    // const setRangeLimits = () => {
    //     if (isNaN(parseFloat(inputValues.min)) && isNaN(parseFloat(inputValues.max))) {
    //         setErrorSelect(2);
    //         return;
    //     } else if (isNaN(parseFloat(inputValues.max))) {
    //         setErrorSelect(3);
    //         return;
    //     } else if (isNaN(parseFloat(inputValues.min))) {
    //         setErrorSelect(4);
    //         return;
    //     } else {
    //         setErrorSelect(0);
    //     }
    //     setMin(parseFloat(inputValues.min));
    //     setMax(parseFloat(inputValues.max));
    // }

    const setRangeLimits = () => {
        const parsedMin = parseFloat(inputValues.min);
        const parsedMax = parseFloat(inputValues.max);

        if (isNaN(parsedMin) && isNaN(parsedMax)) {
            setErrorSelect(2);
            return;
        } else if (isNaN(parsedMax)) {
            setErrorSelect(3);
            return;
        } else if (isNaN(parsedMin)) {
            setErrorSelect(4);
            return;
        } else {
            setErrorSelect(0);
        }

        setMin(parsedMin);
        setMax(parsedMax);

        setValues([parsedMin, parsedMin, parsedMax, parsedMax]);
        setInferiorLimitNotAlert(parsedMin);
        setNormalValue(parsedMin);
        setNormalMaxValue(parsedMax);
        setSuperiorValue(parsedMax);
    }

    // METODOS PARA LA CREACIÓN DE ALERTAS DE TEXTO
    const addReferenceText = () => {
        setIsEdited(true);
        setErrorSelect(0);

        let newTextosReferencia = textosReferencia;
        let range = rangosT.find(x => x.id_analyte_age_gender_range === rangoId);

        ////console.log("HACIENDO UNA PRUEBA: ", range);

        let name = range.genero + "//" + range.rango_edad + " // " + range.metodo;
        let id_aux = -Date.now();

        newTextosReferencia.push({
            id_analyte_text_alert: id_aux,
            id_analyte_age_gender_range: rangoId,
            name_range: name,
            text: inputText
        });

        setInputText("");
        setTextosReferencia(newTextosReferencia);
        // let newRangos = rangosT.filter(x => x.id_analyte_age_gender_range !== rangoId);
        // setRangosT(newRangos);
        setRangoId(0);
    }

    const editReferenceText = (id) => {
        let analyteTextAlert = textosReferencia.find(x => x.id_analyte_text_alert === id);
        let { id_analyte_age_gender_range, name_range, text } = analyteTextAlert;

        if (analyteTextAlertId !== id) {
            // let rango_anterior = textosReferencia.find(x => x.id_analyte_text_alert === analyteTextAlertId);
            // let newRangos = rangosT.filter(x => x.id_analyte_age_gender_range !== (analyteTextAlertId > 0 ? rango_anterior.id_analyte_age_gender_range : 0));
            // let rango = listRanges.find(x => x.id_analyte_age_gender_range === id_analyte_age_gender_range);
            // // ////console.log(newRangos);
            // newRangos.push(rango);
            // setRangosT(newRangos);
            setRangoId(id_analyte_age_gender_range);
            setAnalyteTextAlertId(id);
        }

        setInputText(text);
        setNameRange(name_range);
        setMethodActive("edit");

    }

    const saveEditReferenceText = () => {
        let newTextosReferencia = textosReferencia;
        newTextosReferencia.map((obj, key) => {
            if (obj.id_analyte_text_alert === analyteTextAlertId) {
                let range = rangosT.find(x => x.id_analyte_age_gender_range === rangoId);
                let name = range.genero + " // " + range.rango_edad + " // " + range.metodo;

                obj.id_analyte_text_alert = analyteTextAlertId;
                obj.id_analyte_age_gender_range = rangoId;
                obj.name_range = name;
                obj.text = inputText
            }
            return obj;
        });

        setInputText("");

        // let newRangos = rangosT.filter(x => x.id_analyte_age_gender_range !== rangoId);
        // setRangosT(newRangos);
        setRangoId(0);
        setAnalyteTextAlertId(0);
        setMethodActive("create");
    }

    const removeReferenceText = async (id) => {

        if (id > 0) {
            let requestOptions = {
                method: 'DELETE',
                redirect: 'follow'
            };

            const respuesta = await sendRequest(requestOptions, `Exam/DeleteAnalyteTextAlert/${id}`);
            if (respuesta.code === 200) {

            } else {
                validarSesion(history, respuesta.code, removeReferenceText);
            }
        }
        // let newRangos = null;
        // // ////console.log(textosReferencia);
        // // if (analyteTextAlertId !== 0) {
        // if (id !== 0) {
        //     let rango_anterior = textosReferencia.find(x => x.id_analyte_text_alert === analyteTextAlertId);
        //     newRangos = rangosT.filter(x => x.id_analyte_age_gender_range !== (analyteTextAlertId > 0 ? rango_anterior.id_analyte_age_gender_range : 0));
        // } else {
        //     newRangos = rangos;
        // }
        // let rangeId = textosReferencia.find(x => x.id_analyte_text_alert === id).id_analyte_age_gender_range;
        // let rango = listRanges.find(x => x.id_analyte_age_gender_range === rangeId);

        // newRangos.push(rango);
        // setRangosT(newRangos);

        let newTextosReferencia = textosReferencia.filter(x => x.id_analyte_text_alert !== id);
        setTextosReferencia(newTextosReferencia);
    }

    const saveReferenceTexts = () => {
        saveTempAnalytesTextAlerts(textosReferencia);
    }

    //-------------------------------------------------

    const addReferenceValue = () => {
        setIsEdited(true);
        setErrorSelect(0);
        if (rangoId === 0) {
            setErrorSelect(1);
            return;
        }

        let newValoresReferencia = valoresReferencia;
        let range = rangos.find(x => x.id_analyte_age_gender_range === rangoId);
        let name =  range.genero + "//" + range.rango_edad + " // " + range.metodo;
        let id_aux = -Date.now();

        newValoresReferencia.push({
            id_analyte_number_alert: id_aux,
            id_analyte_age_gender_range: rangoId,
            name_range: name,
            low_alert: min,
            low: values[0],
            normal_min: values[1],
            normal_max: values[2],
            high: values[3],
            high_alert: max,
        })
        setValoresReferencia(newValoresReferencia);
        setInputValues({
            min: 0,
            max: 100
        });
        setMin(0);
        setMax(100);
        setValues([20, 40, 60, 80]);
        let newRangos = rangos.filter(x => x.id_analyte_age_gender_range !== rangoId);
        setRangos(newRangos);
        setRangoId(0);
        setAnalyteNumberAlertId(0);
    }

    const editReferenceValue = (id) => {
        let analyteNumberAlert = valoresReferencia.find(x => x.id_analyte_number_alert === id);
        let { id_analyte_age_gender_range, name_range, low_alert, low, normal_min, normal_max, high, high_alert } = analyteNumberAlert;
        if (analyteNumberAlertId !== id) {
            let rango_anterior = valoresReferencia.find(x => x.id_analyte_number_alert === analyteNumberAlertId);
            let newRangos = rangos.filter(x => x.id_analyte_age_gender_range !== (analyteNumberAlertId > 0 ? rango_anterior.id_analyte_age_gender_range : 0));
            let rango = listRanges.find(x => x.id_analyte_age_gender_range === id_analyte_age_gender_range);
            newRangos.push(rango);
            setRangos(newRangos);
            setRangoId(id_analyte_age_gender_range);
            setAnalyteNumberAlertId(id);
        }
        setInputValues({
            min: low_alert,
            max: high_alert
        });
        setMin(low_alert);
        setMax(high_alert);
        setValues([low, normal_min, normal_max, high]);
        setNameRange(name_range);
        setMethodActive("edit");
    }

    const saveEditReferenceValue = () => {
        let newValoresReferencia = valoresReferencia;
        newValoresReferencia.map((obj, key) => {
            if (obj.id_analyte_number_alert === analyteNumberAlertId) {
                let range = rangos.find(x => x.id_analyte_age_gender_range === rangoId);
                let name = range.genero + "//" + range.rango_edad + " // " + range.metodo;

                obj.id_analyte_number_alert = analyteNumberAlertId;
                obj.id_analyte_age_gender_range = rangoId;
                obj.name_range = name;
                obj.low_alert = min;
                obj.low = values[0];
                obj.normal_min = values[1];
                obj.normal_max = values[2];
                obj.high = values[3];
                obj.high_alert = max;
            }
            return obj;
        });
        setValoresReferencia(newValoresReferencia);
        setInputValues({
            min: 0,
            max: 100
        });
        setMin(0);
        setMax(100);
        setValues([20, 40, 60, 80]);
        let newRangos = rangos.filter(x => x.id_analyte_age_gender_range !== rangoId);
        setRangos(newRangos);
        setRangoId(0);
        setAnalyteNumberAlertId(0);
        setMethodActive("create");
    }

    const removeReferenceValue = async (id) => {
        const confirmed = await sweetAlertGlobal(
            "Eliminar valor de referencia",
            "¿Estás seguro de eliminar este valor?",
            "warning",
            true
        );

        if (!confirmed) return;

        if (id > 0) {
            let requestOptions = {
                method: 'DELETE',
                redirect: 'follow'
            };

            const respuesta = await sendRequest(requestOptions, `Exam/DeleteAnalyteNumberAlert/${id}`);
            if (respuesta.code === 200) {
                await sweetAlertGlobal("Éxito", "El valor fue eliminado correctamente.", "success");
            } else {
                validarSesion(history, respuesta.code, removeReferenceValue);
            }
        }

        let newRangos = null;
        if (analyteNumberAlertId > 0) {
            let rango_anterior = valoresReferencia.find(x => x.id_analyte_number_alert === analyteNumberAlertId);
            newRangos = rangos.filter(x => x.id_analyte_age_gender_range !== (analyteNumberAlertId > 0 ? rango_anterior.id_analyte_age_gender_range : 0));
        } else {
            newRangos = rangos;
        }
        let rangeId = valoresReferencia.find(x => x.id_analyte_number_alert === id).id_analyte_age_gender_range;
        let rango = listRanges.find(x => x.id_analyte_age_gender_range === rangeId);
        newRangos.push(rango);
        setRangos(newRangos);

        let newValoresReferencia = valoresReferencia.filter(x => x.id_analyte_number_alert !== id);
        ////console.log(newValoresReferencia);
        setValoresReferencia(newValoresReferencia);
    }

    const handleInputChange = ({ target }) => {
        setRangoId(parseInt(target.value));
    }

    const saveReferenceValues = () => {
        saveTempAnalytesNumberAlerts(valoresReferencia);
    }

    const backToCreate = () => {
        setInputValues({
            min: 0,
            max: 100
        });
        setMin(0);
        setMax(100);
        setValues([20, 40, 60, 80]);
        let newRangos = rangos.filter(x => x.id_analyte_age_gender_range !== rangoId);
        setRangos(newRangos);
        setRangoId(0);
        setMethodActive("create");
        setMethodActive("create");
    }

    useEffect(() => {
        backToCreate();
    }, [name])


    const msgErrors = () => {
        switch (errorSelect) {
            case 0:
                return "";
                break;
            case 1:
                return "Debes de seleccionar un rango para agregar los valores de referencia";
                break;
            case 2:
                return "Los valores de límite inferior y superior con alerta no pueden estar vacíos.";
                break;
            case 3:
                return "El límite superior con alerta no puede estar vacío.";
                break;
            case 4:
                return "El límite inferior con alerta no puede estar vacío.";
                break;
            default:
                return ""
                break;
        }
    }

    const handleChangeNumericValues = (e, indice) => {
        let copyValues = values;
        let valAfter = copyValues[indice];

        if (e.target.name === "inferiorLimitNotAlert") {
            setInferiorLimitNotAlert(e.target.value);

            if (e.target.value !== '') {
                copyValues[indice] = parseFloat(e.target.value);

                setInputIndex(indice);
                setValues([...copyValues]);
            }
        }
        else if (e.target.name === "normalValue") {
            setNormalValue(e.target.value);

            if (e.target.value !== '') {
                copyValues[indice] = parseFloat(e.target.value);

                setInputIndex(indice);
                setValues([...copyValues]);
            }
        }
        else if (e.target.name === "normalMaxValue") {
            setNormalMaxValue(e.target.value);

            if (e.target.value !== '') {
                copyValues[indice] = parseFloat(e.target.value);

                setInputIndex(indice);
                setValues([...copyValues]);
            }
        }
        else if (e.target.name === "superiorValue") {
            setSuperiorValue(e.target.value);

            if (e.target.value !== '') {
                copyValues[indice] = parseFloat(e.target.value);

                setInputIndex(indice);
                setValues([...copyValues]);
            }
        }

        if (indice == 0) {
            if ((valAfter == copyValues[1]) && (valAfter == copyValues[2]) && (valAfter == copyValues[3])) {
                copyValues[1] = parseFloat(max);
                copyValues[2] = parseFloat(max);
                copyValues[3] = parseFloat(max);

                setValues([...copyValues]);
            }
        }
    }

    useEffect(() => {
        const valuesCopy = [...values].map((value) => {
            return parseFloat(checkValuesAgainstBoundaries(value, min, max));
        });
        setValues(valuesCopy);
        setInputIndex(-1)
    }, [min, max]);


    useEffect(() => {
        let newListRanges = [];
        if (listReferenceValues.length > 0) {
            listRanges.forEach((rango) => {
                let valdiacion = false;
                listReferenceValues.forEach((obj) => {
                    if (rango.id_analyte_age_gender_range === obj.id_analyte_age_gender_range) {
                        valdiacion = true;
                    }
                })
                if (!valdiacion) {
                    newListRanges.push(rango);
                }
            })
        } else {
            newListRanges = listRanges;
        }
        setValoresReferencia(listReferenceValues);
        setRangos(newListRanges);
    }, [listReferenceValues, listRanges])


    useEffect(() => {
        let newListRanges = [];
        if (listReferenceTexts.length > 0) {
            listRanges.forEach((rango) => {
                let valdiacion = false;
                listReferenceTexts.forEach((obj) => {
                    if (rango.id_analyte_age_gender_range === obj.id_analyte_age_gender_range) {
                        valdiacion = true;
                    }
                })
                if (!valdiacion) {
                    newListRanges.push(rango);
                }
            })
        } else {
            newListRanges = listRanges;
        }
        setTextosReferencia(listReferenceTexts);
        setRangosT(listRanges);
    }, [listReferenceTexts, listRanges])

    const [referenceTypes, setReferenceTypes] = useState([]);

    useEffect(() => {
        getReferenceTypes().then(result => {
            if (result.length > 0) {
                setCheckTypeReference(result[0].id)
            }
        })

        return () => {

        }
    }, [])

    const [checkTypeReference, setCheckTypeReference] = useState(referenceTypes.length > 0 ? referenceTypes[0].id : 0);

    const getReferenceTypes = async () => {
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        const respuesta = await sendRequest(requestOptions, `Exam/GetReferencesTypes`);
        if (respuesta.code === 200) {
            let referenceTypesAux = [];
            Object.entries(respuesta.data).forEach(element => {
                let newObj = {
                    "id": parseInt(element[0]),
                    "name": element[1],
                }
                referenceTypesAux.push(newObj);
            });
            setReferenceTypes(referenceTypesAux);
            return referenceTypesAux;
        } else {
            validarSesion(history, respuesta.code, getReferenceTypes);
        }
    }

    useEffect(() => {
        let copy = values;

        if (copy.length > 0 && inputIndex >= 0) {

            let val = copy[inputIndex];

            if (inputIndex === 0) {
                if (val > min && val <= values[1]) {
                    copy[inputIndex] = val;
                    setInferiorLimitNotAlert(val);
                }
                else {
                    copy[inputIndex] = parseFloat(min);
                    setInferiorLimitNotAlert(min);
                }
            }
            else if (inputIndex == 1) {

                if (val > values[0] && val <= values[2]) {

                    copy[inputIndex] = val;
                    setNormalValue(val);
                }
                else {
                    copy[inputIndex] = parseFloat((values[0]).toFixed(2));
                    setNormalValue(parseFloat((values[0]).toFixed(2)));
                }
            }
            else if (inputIndex == 2) {

                if (val > values[1] && val <= values[3]) {

                    copy[inputIndex] = val;
                    setNormalMaxValue(val);
                }
                else {
                    copy[inputIndex] = parseFloat((values[1]).toFixed(2));

                    setNormalMaxValue(parseFloat((values[1]).toFixed(2)));
                }
            }
            else if (inputIndex == 3) {

                if (val > values[2] && val <= max) {

                    copy[inputIndex] = val;
                    setSuperiorValue(val);
                }
                else {
                    copy[inputIndex] = parseFloat((values[2]).toFixed(2));

                    setSuperiorValue(parseFloat((values[2]).toFixed(2)));
                }
            }
        }
        else if (inputIndex == -1) {
            setInferiorLimitNotAlert(values[0]);
            setNormalValue(values[1]);
            setNormalMaxValue(values[2]);
            setSuperiorValue(values[3]);
        }

        setValues([...copy]);

    }, [debounceValue]);

    // console.log("🚀 ~ removeReferenceText ~ valoresReferencia:", valoresReferencia)
    // console.log("🚀 ~ removeReferenceText ~ valoresReferencia:", valoresReferencia.length)

    // console.log("🚀 ~ removeReferenceText ~ tabTypeAnalyte:", tabTypeAnalyte)
    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "10px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => editReferenceValue(rowData.id_analyte_number_alert)}
                    title="Editar Perfil"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => removeReferenceValue(rowData.id_analyte_number_alert)}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

        const actionsText = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => editReferenceText(rowData.id_analyte_text_alert)}
                    title="Editar Perfil"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => removeReferenceText(rowData.id_analyte_text_alert)}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    const emptyTableTemplate = (
        <div className="text-center">
            <img
                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                style={{ width: "35%" }}
                alt="Sin lista de valores"
            />
            <br />
            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                Sin valores.
            </p>
        </div>
    );
                
    // const handleChangeReferenceType = async (newTypeId) => {
    //     // Detectar cambios sin guardar
    //     const hasUnsavedChanges =
    //         isEdited ||
    //         valoresReferencia.some(v => v.id_analyte_number_alert < 0) || 
    //         textosReferencia.some(t => t.id_analyte_text_alert < 0);

    //     if (hasUnsavedChanges) {
    //         const confirmed = await sweetAlertGlobal(
    //             "Atención",
    //             "Estás cambiando el tipo de referencia. Los valores que no guardaste se limpiarán. ¿Deseas continuar?",
    //             "warning",
    //             true
    //         );

    //         if (!confirmed) return;
    //     }

    //     // Seleccionar opciones según tipo ANTES de limpiar
    //     let availableRanges = [];
    //     if (newTypeId === 1) {
    //         availableRanges = listRanges.filter(
    //             r => !valoresReferencia.some(v => v.id_analyte_age_gender_range === r.id_analyte_age_gender_range)
    //         );
    //         setRangos(availableRanges);
    //     } else {
    //         availableRanges = listRanges.filter(
    //             r => !textosReferencia.some(t => t.id_analyte_age_gender_range === r.id_analyte_age_gender_range)
    //         );
    //         setRangosT(availableRanges);
    //     }
        
    //     setRangoId(0);

    //     setValoresReferencia(prev => prev.filter(v => v.id_analyte_number_alert >= 0));
    //     setTextosReferencia(prev => prev.filter(t => t.id_analyte_text_alert >= 0));

    //     // Reset de inputs visuales
    //     setInputValues({ min: 0, max: 100 });
    //     setMin(0);
    //     setMax(100);
    //     setValues([20, 40, 60, 80]);
    //     setMethodActive("create");
    //     setCheckTypeReference(newTypeId);
    //     setIsEdited(false);
    // };


    return (
        <Row>
            <Col sm="12">
            <div   style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", scrollBehavior: "smooth", transform: "scale(0.8)", width: "125%", transformOrigin: "top left", textAlign: "justify" }}>


            </div>
                <Row>
                    <Col sm="4">
                        <FormGroup className="mb-3 pl-1 pr-1">
                        <Label className="f-w-600 f-12 badge badge-light-primary text-center d-block mb-2">
                            Selecciona el tipo de referencia a ocupar
                        </Label>
                        <FormGroup className="m-t-15 m-checkbox-inline mb-0 custom-radio-ml text-center">
                            {referenceTypes.map(referenceType => (
                            <div key={`radioType${referenceType.id}`} className="radio radio-primary">
                                <Input
                                id={`rType${referenceType.id}`}
                                type="radio"
                                name="rTypes"
                                value={referenceType.id}
                                checked={checkTypeReference === referenceType.id}
                                onChange={() => setCheckTypeReference(referenceType.id)}
                                />
                                
                                <Label for={`rType${referenceType.id}`}>{referenceType.name}</Label>
                            </div>
                            ))}
                        </FormGroup>
                        </FormGroup>
                    </Col>

                    <Col sm="3">
                        <FormGroup className="mb-3 pl-1 pr-1">
                        <Label className="f-w-600 f-12 badge badge-light-primary text-center d-block mb-2">
                            Rango
                        </Label>
                        <Select
                            classNamePrefix="select"
                            name="rangoId"
                            placeholder="Selecciona una opción"
                            isDisabled={tabTypeAnalyte === 2}
                            options={(checkTypeReference === 1 ? rangos : rangosT).map(l => ({
                                value: l.id_analyte_age_gender_range,
                                label: `${l.genero} // ${l.rango_edad} // ${l.metodo}`
                            }))}
                            value={(checkTypeReference === 1 ? rangos : rangosT)
                                .map(l => ({
                                value: l.id_analyte_age_gender_range,
                                label: `${l.genero} // ${l.rango_edad} // ${l.metodo}`
                                }))
                                .find(opt => opt.value === rangoId) || null}
                            onChange={e =>
                                handleInputChange({
                                target: { name: "rangoId", value: e ? e.value : 0 }
                                })
                            }
                            menuPortalTarget={document.body} 
                            menuPosition="fixed"         
                            styles={{
                                menuPortal: base => ({
                                ...base,
                                zIndex: 999999
                                }),
                                control: base => ({
                                ...base,
                                borderRadius: "10px"
                                })
                            }}
                            />
                        </FormGroup>
                    </Col>

                    {checkTypeReference === 1 ? (
                        <>
                        <Col sm="2">
                            <FormGroup className="mb-3 pl-1 pr-1">
                            <Label className="f-w-600 f-12 badge badge-light-primary text-center d-block mb-2">
                                Límite inferior con alerta
                            </Label>
                            <Input
                                readOnly={tabTypeAnalyte === 2}
                                bsSize="sm"
                                placeholder="Límite inferior con alerta"
                                type="number"
                                name="min"
                                value={inputValues.min}
                                required
                                autoComplete="off"
                                onChange={handleRangeLimit}
                                className="form-control form-control-sm input-air-primary b-r-9"
                                invalid={errorSelect === 4 || errorSelect === 2}
                            />
                            </FormGroup>
                        </Col>

                        <Col sm="2">
                            <FormGroup className="mb-3 pl-1 pr-1">
                            <Label className="f-w-600 f-12 badge badge-light-primary text-center d-block mb-2">
                                Límite superior con alerta
                            </Label>
                            <Input
                                readOnly={tabTypeAnalyte === 2}
                                bsSize="sm"
                                placeholder="Límite superior con alerta"
                                type="number"
                                name="max"
                                value={inputValues.max}
                                required
                                autoComplete="off"
                                onChange={handleRangeLimit}
                                className="form-control form-control-sm input-air-primary b-r-9"
                                invalid={errorSelect === 3 || errorSelect === 2}
                            />
                            </FormGroup>
                        </Col>

                        <Col sm="1" style={{marginTop:'20px'}}>
                            {tabTypeAnalyte !== 2 && (
                            <FormGroup className="mb-3 pl-1 pr-1" style={{ display: "flex", justifyContent: "end", flexDirection: "column-reverse" }}>
                                <Button onClick={setRangeLimits} className="btn-icon btn-2 btn-sm" color="primary" type="button">
                                <i className="fa fa-check" />
                                </Button>
                            </FormGroup>
                            )}
                        </Col>
                        </>
                    ) : (
                        <>
                        <Col sm="3">
                            <FormGroup className="mb-3 pl-1 pr-1">
                            <Label className="f-w-600 f-12 badge badge-light-primary text-center d-block mb-2">
                                Referencia tipo texto
                            </Label>
                            <Input
                                readOnly={tabTypeAnalyte === 2}
                                bsSize="sm"
                                placeholder="Texto..."
                                type="text"
                                name="text_alert"
                                value={inputText}
                                required
                                autoComplete="off"
                                onChange={changeInputText}
                                className="form-control form-control-sm input-air-primary b-r-9"
                            />
                            </FormGroup>
                        </Col>

                        <Col sm="2" style={{marginTop:'30px'}}>
                            <FormGroup className="mb-3 pl-1 pr-1" style={{ display: "flex", justifyContent: "end", flexDirection: "column-reverse" }}>
                            <Button
                                onClick={methodActive === "edit" ? saveEditReferenceText : addReferenceText}
                                className="btn-icon btn-2 btn-sm"
                                color="primary"
                                type="button"
                            >
                                {methodActive === "edit" ? "Editar" : "Agregar"}
                            </Button>
                            </FormGroup>
                        </Col>
                        </>
                    )}
                </Row>
           

                {
                    checkTypeReference === 1 &&
                    <>
                        <div style={{ 
                                    backgroundColor: '#587d95', 
                                    color: '#fff', 
                                    padding: '5px 10px', 
                                    borderRadius: '8px', 
                                    marginBottom: '10px', 
                                    fontWeight: 'bold', 
                                    textAlign: 'center',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                valores de referencia numérica
                            </div>
                        
                        <Row>
                
                            <Col sm="3">
                                {/* <Card className='shadow-sm border height-equal pricingtable'   style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "115%", transformOrigin: "top left", textAlign: "justify" }}> */}
                            
                                    <Row className="gx-2 gy-3">
                                    <Col sm="12">
                                        <div className="rounded-4 shadow-sm p-3 h-100" 
                                            style={{
                                                // backgroundImage: "linear-gradient(135deg, #faf9b5ff, #fffcefff)",
                                                border: "1.5px solid #f3f040ff", 
                                                borderRadius: "12px",
                                            }}
                                        >      
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span style={{ color: "#020202ff" }} className="fw-semibold">
                                                Límite inferior sin alerta
                                            </span>
                                            <i className="fa fa-arrow-down" style={{ color: "#ffd600", marginLeft: "8px" }}></i>
                                        </div>

                                    
                                        <Input
                                            bsSize="sm"
                                            type="number"
                                            name="inferiorLimitNotAlert"
                                            step={STEP}
                                            min={min}
                                            max={values[1]}
                                            placeholder="0.00"
                                            value={inferiorLimitNotAlert}
                                            className="form-control text-center border-1 bg-light rounded-3"
                                            onChange={(e) => handleChangeNumericValues(e, 0)}
                                        style={{ color: "#000000ff", borderRadius: "10px" }} 
                                        />
                                        </div>
                                    </Col>

                                        <Col sm="12" className='mt-3'>
                                            <div className="rounded-4 shadow-sm p-3 h-100" 
                                                style={{
                                                    // backgroundImage: "linear-gradient(135deg, #ccfad0ff, #f5fffbff)",
                                                    border: "1.5px solid #31d68fff", 
                                                    borderRadius: "12px",
                                                }}
                                            >                                        
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{ color: "#020202ff" }} className="fw-semibold">
                                                    Valor normal mínimo
                                                </span>
                                                <i className="fa fa-minus" style={{ color: "#2dce89", marginLeft: "8px" }}></i>
                                            </div>        

                                            
                                            <Input
                                                bsSize="sm"
                                                type="number"
                                                name="normalValue"
                                                step={STEP}
                                                min={min}
                                                max={max}
                                                placeholder="0.00"
                                                value={normalValue}
                                                className="form-control text-center border-1 bg-light rounded-3"
                                                onChange={(e) => handleChangeNumericValues(e, 1)}
                                            style={{ color: "#000000ff", borderRadius: "10px" }} 
                                            />
                                            </div>
                                        </Col>

                                        <Col sm="12" className='mt-3'>
                                            <div className="rounded-4 shadow-sm p-3 h-100" 
                                                style={{
                                                    // backgroundImage: "linear-gradient(135deg, #ccfad0ff, #f5fffbff)",
                                                    border: "1.5px solid #31d68fff", 
                                                    borderRadius: "12px",
                                                }}
                                            >    
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{ color: "#020202ff" }} className="fw-semibold">
                                                    Valor normal máximo
                                                </span>
                                                <i className="fa fa-plus text-info" style={{ color: "#2dce89", marginLeft: "8px" }}></i>
                                            </div>                                     
                                        
                                            <Input
                                                bsSize="sm"
                                                type="number"
                                                name="normalMaxValue"
                                                step={STEP}
                                                min={min}
                                                max={max}
                                                placeholder="0.00"
                                                value={normalMaxValue}
                                                className="form-control text-center border-1 bg-light rounded-3"
                                                onChange={(e) => handleChangeNumericValues(e, 2)}
                                            style={{ color: "#000000ff", borderRadius: "10px" }} 
                                            />
                                            </div>
                                        </Col>

                                        <Col sm="12" className='mt-3'>
                                            <div className="rounded-4 shadow-sm p-3 h-100" 
                                                style={{
                                                    // backgroundImage: "linear-gradient(135deg, #faf9b5ff, #fffcefff)",
                                                    border: "1.5px solid #f3f040ff", 
                                                    borderRadius: "12px",
                                                }}
                                            >     
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{ color: "#020202ff" }} className="fw-semibold">
                                                    Límite superior sin alerta
                                                </span>
                                                <i className="fa fa-arrow-up" style={{ color: "#ffd600", marginLeft: "8px" }}></i>
                                            </div>

                                            <Input
                                                bsSize="sm"
                                                type="number"
                                                name="superiorValue"
                                                step={STEP}
                                                min={min}
                                                max={max}
                                                placeholder="0.00"
                                                value={superiorValue}
                                                className="form-control text-center border-1 bg-light rounded-3"
                                                onChange={(e) => handleChangeNumericValues(e, 3)}
                                                style={{ color: "#000000ff", borderRadius: "10px" }} 
                                            />
                                            </div>
                                        </Col>

                               
                                        {tabTypeAnalyte !== 2 && (
                                            <Col sm="12" className="text-right">
                                                <p className="text-danger">{msgErrors()}</p>
                                                <Button
                                                onClick={methodActive === 'edit' ? saveEditReferenceValue : addReferenceValue}
                                                color="primary"
                                                className="btn-block btn-sm"
                                                style={{borderRadius:'10px'}}
                                                >
                                                {methodActive === 'edit'
                                                    ? 'Editar valores de referencia'
                                                    : 'Agregar valores de referencia y alertas'}
                                                </Button>
                                            </Col>
                                        )}
                                        <br />

                                

                                        
                                    </Row>
                                {/* </Card> */}
                            
                            </Col>

                            <Col sm="9" >
                                {/* <Card className='shadow-sm border height-equal pricingtable'   style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", scrollBehavior: "smooth", transform: "scale(0.8)", width: "125%", transformOrigin: "top left", textAlign: "justify" }}> */}
                                {/* {valoresReferencia.length > 0 && ( */}
                                    <div>
                                        <DataTable
                                            value={valoresReferencia}
                                            paginator={valoresReferencia.length > 6}
                                            rows={6}
                                            rowsPerPageOptions={valoresReferencia.length > 6 ? [6,10, 50, 100] : []}
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={emptyTableTemplate}
                                            responsiveLayout="scroll"
                                        >
                                        <Column
                                            body={(rowData, { rowIndex }) => rowIndex + 1}
                                            header="#"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />

                                        <Column
                                            field="name_range"
                                            header="Rango"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => <strong>{rowData.name_range}</strong>}

                                            
                                        />

                                        <Column
                                            field="low_alert"
                                            header="Inferior con alerta"
                                            body={(rowData) => (
                                            <div className="text-center">
                                                <p>
                                                {rowData.low_alert} <i className="fa fa-angle-double-down" style={{ color: "#f5365c" }}></i>
                                                </p>
                                            </div>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="low"
                                            header="Inferior sin alerta"
                                            body={(rowData) => (
                                            <div className="text-center">
                                                <p>
                                                {rowData.low} <i className="fa fa-angle-down" style={{ color: "#e0bc00" }}></i>
                                                </p>
                                            </div>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="normal_min"
                                            header="Normal mínimo"
                                            body={(rowData) => (
                                            <div className="text-center">
                                                <p>
                                                {rowData.normal_min} <i className="fa fa-angle-down" style={{ color: "#2dce89" }}></i>
                                                </p>
                                            </div>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="normal_max"
                                            header="Normal máximo"
                                            body={(rowData) => (
                                            <div className="text-center">
                                                <p>
                                                {rowData.normal_max} <i className="fa fa-angle-up" style={{ color: "#2dce89" }}></i>
                                                </p>
                                            </div>
                                            )}
                                            
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="high"
                                            header="Superior sin alerta"
                                            body={(rowData) => (
                                            <div className="text-center">
                                                <p>
                                                {rowData.high} <i className="fa fa-angle-up" style={{ color: "#e0bc00" }}></i>
                                                </p>
                                            </div>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="high_alert"
                                            header="Superior con alerta"
                                            body={(rowData) => (
                                            <div className="text-center">
                                                <p>
                                                {rowData.high_alert} <i className="fa fa-angle-double-up" style={{ color: "#f5365c" }}></i>
                                                </p>
                                            </div>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        {tabTypeAnalyte !== 2 && (
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />

                                        )}                                    
                                    
                                        </DataTable>
                                    </div>
                                    {/* )} */}
                                    {
                        
                                        valoresReferencia.length > 0 &&
                                        <Col className="text-right pt-2 pb-3" sm="12" style={{marginTop:'20px'}}>
                                            <Button onClick={saveReferenceValues} color="success" className="btn-block">
                                                Confirmar valores de referencia
                                            </Button>
                                        </Col>
                                    }
                                    {/* </Card> */}
                            

                            
                            </Col>
                        </Row>

                         
                        {/* <Col sm='12' style={{marginTop:'40px'}}>
                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                <Range
                                disabled={true}
                                values={values}
                                step={STEP}
                                min={min}
                                max={max}
                                onChange={(values) => setValues(values)}
                                renderTrack={({ props, children }) => (
                                    <div
                                    onMouseDown={props.onMouseDown}
                                    onTouchStart={props.onTouchStart}
                                    style={{
                                        ...props.style,
                                        height: '36px',
                                        display: 'flex',
                                        width: '100%',
                                    }}
                                    >
                                    <div
                                        ref={props.ref}
                                        style={{
                                        height: '5px',
                                        width: '100%',
                                        borderRadius: '4px',
                                        background: getTrackBackground({
                                            values,
                                            colors: COLORS,
                                            min: min,
                                            max: max,
                                        }),
                                        alignSelf: 'center',
                                        }}
                                    >
                                        {children}
                                    </div>
                                    </div>
                                )}
                                renderThumb={({ props, isDragged, index }) => (
                                    <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        height: '22px',
                                        width: '22px',
                                        borderRadius: '4px',
                                        backgroundColor: '#FFF',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        boxShadow: '0px 2px 6px #AAA',
                                    }}
                                    >
                                    <div
                                        style={{
                                        position: 'absolute',
                                        top: '-32px',
                                        color: `#${index === 0 || index === 3 ? '3c3c3c' : '272727'}`,
                                        fontWeight: 'normal',
                                        fontSize: '14px',
                                        padding: '5px',
                                        borderRadius: '4px',
                                        backgroundColor: `#${index === 0 || index === 3 ? 'ffd600' : '2dce89'}`,
                                        }}
                                    >
                                        {values[index].toFixed(2)}
                                    </div>
                                    <div
                                        style={{
                                        height: '16px',
                                        width: '5px',
                                        backgroundColor: isDragged ? '#5e72e4' : '#CCC',
                                        }}
                                    />
                                    </div>
                                )}
                                />
                            </div>

                            <Row className="mt-2">
                                <Col sm="8" className="text-left">
                                Límite inferior con alerta
                                <br />
                                <h5 className="text-danger">{min}</h5>
                                </Col>
                                <Col sm="4" className="text-right">
                                Límite superior con alerta
                                <br />
                                <h5 className="text-danger">{max}</h5>
                                </Col>
                            </Row>
                             
                                    
                        
                        </Col> */}
                        
                        <br />
                        
                        <Col sm='12'>
                        
                               
                        
                        </Col>
                    
                    </>
                }

                {
                    checkTypeReference === 2 &&
                    <Row>
                        <Col sm='12'>
                            <Card className='shadow-sm border height-equal pricingtable'>

                                <DataTable
                                value={textosReferencia}
                                paginator={textosReferencia.length > 10}
                                rows={10}
                                rowsPerPageOptions={textosReferencia.length > 10 ? [10, 50, 100] : []}
                                className="data-table p-datatable-striped p-datatable-sm"
                                emptyMessage={
                                    <div className="text-center">
                                    <img
                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                        style={{ width: "35%" }}
                                        alt="Sin lista de valores"
                                    />
                                    <br />
                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                        Sin valores de referencia de texto.
                                    </p>
                                    </div>
                                }
                                responsiveLayout="scroll"
                                >
                                    
                                <Column
                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                    header="#"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />
                                    
                                <Column
                                    field="name_range"
                                    header="Rango"
                                    body={(rowData) => <strong>{rowData.name_range}</strong>}
                                    headerStyle={headerStyle}
                                                style={cellStyle}
                                />

                                <Column
                                    field="text"
                                    header="Texto"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />

                                <Column header="Acciones" body={actionsText} exportable={false} headerStyle={headerStyle} style={cellStyle} />


                                
                                </DataTable>
                            </Card>
                        
                        </Col>

                        <Col >
                            {
                                tabTypeAnalyte !== 2 &&
                                textosReferencia.length > 0 &&
                                <Col className="text-right pt-2" sm="12">
                                    <Button onClick={saveReferenceTexts} color="primary" className="btn-block">
                                        Confirmar textos de referencia
                                    </Button>
                                </Col>
                            }
                        </Col>
                    </Row>
                }

            </Col>
           
            <Col sm="7" className='pt-4 pb-5'>
            </Col>
        </Row >

    );
                    
};